import * as Ajax from '../ajax/Ajax';
/**
 * 売上情報を取得します。
 *
 * @param targetYear 対象年
  * @param fn ファンクション
 */

export function GetSales(targetYear, fn) {
  Ajax.Post("SalesApi/GetSales", {
    targetYear: targetYear
  }, Ajax.ModelResult(fn));
}